<template>

<div class="input checklist" :data-theme="theme">

    <div class="checklist-item" v-for="option in options" :key="option.value" :class="{'is-active': option.value === value}" v-on:click="$emit('input', option.value)">

        <div class="checklist-item-name">{{ option.text }}</div>
        <div class="checklist-item-description">{{ option.description }}</div>
        <div class="checklist-item-icon" v-if="option.value === value">
            <i class="fa-sharp fa-check" />
        </div>

    </div>

</div>

</template>

<script>

export default {

	props: [
		'options', 'theme', 'value'
	]

}

</script>

<style scoped>

.checklist {
    
}

.checklist-item {
    background-color: #3c6981;
    color: #fff;
    font-weight: 400;
    padding: 10px;
    margin-bottom: 1px;
    padding-right: 40px;
    cursor: pointer;
    min-height: 44px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    user-select: none;
}

.is-mobile .checklist-item {
    margin-bottom: 0px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.25);
}

.checklist-item:hover {
    background-color: #487994;
}

.checklist-item:first-child {
    border-radius: 4px 4px 0px 0px;
}

.checklist-item:last-child {
    border-bottom: 0px;
    border-radius: 0px 0px 4px 4px;
}

.checklist-item-name {
    color: #fff;
    font-size: 14px;
    font-weight: 500;
}

.checklist-item-description {
    color: #fff;
    font-size: 14px;
    line-height: 18px;
    opacity: 0.8;
    margin-top: 2px;
    font-weight: 300;
}

.checklist-item-icon {
    position: absolute;
    right: 10px;
    top: 50%;
    margin-top: -12px;
    height: 24px;
    width: 24px;
    text-align: center;
    line-height: 24px;
    font-size: 14px;
    background-color: rgba(0, 0, 0, 0.05);
    border-radius: 4px;
    color: rgba(255, 255, 255, 0.25);
}

.checklist-item:hover .checklist-item-icon {
    color: rgba(255, 255, 255, 1);
}

.checklist-item.is-active .checklist-item-icon {
    background-color: rgba(43, 88, 112, 1);
    color: rgba(255, 255, 255, 1);
}

</style>
